export class SourcingUpdate {

}

export class InsertSourcing {
  id: string='';
  sourcingBatchId: string='';
  requirementIds : string[] = [];
  salesPersonId : string='';
  }
